import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DownloadReportMutation } from "../graphql/mutations";
import type {
  DownloadReportMutationType,
  DownloadReportMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDownloadReportMutation = (
  options?: MutationHookOptions<
    DownloadReportMutationType,
    DownloadReportMutationVariablesType
  >
) => {
  return useMutation<
    DownloadReportMutationType,
    DownloadReportMutationVariablesType
  >(DownloadReportMutation, options);
};
